import { Col, Layout, Row, Menu } from 'antd';
import { MailOutlined, LineChartOutlined, 
  SearchOutlined, ProfileOutlined, 
  MenuFoldOutlined, DownloadOutlined, FileOutlined, CommentOutlined } from '@ant-design/icons';

import React from 'react';
import './App.css';
import DataRunsContainer from '../container/DataRunsContainer';
import IntroView from './IntroView';
import Banner from './trans_banner.png';
// import DataView from "./DataView";
//import SidePanel from '../components/SidePanel';
const { Content, Header, Sider } = Layout;
export interface IProps{
  changeMode:any, 
  view_mode:number,
  changeViewMode:any
}
export interface IState {
    contentWidth:number,
    contentHeight:number,
    screenWidth:number,
    screenHeight:number,
    menu_selected_keys:any,
    
}
function download(file:any, text:any) {
              
  //creating an invisible element
  var element = document.createElement('a');
  element.setAttribute('href', text);
  element.setAttribute('download', file);

  // Above code is equivalent to
  // <a href="path of file" download="file name">

  document.body.appendChild(element);

  //onClick property
  element.click();

  document.body.removeChild(element);
}
class App extends React.Component<IProps, IState> {
  public ContentRef:any;
  constructor(props:IProps) {
      super(props);
      this.ContentRef = React.createRef();
      this.onResize = this.onResize.bind(this);
      this.onMenuSelect = this.onMenuSelect.bind(this);
      this.state = {
          contentWidth : 0,
          contentHeight: 0,
          screenHeight: 0,
          screenWidth :0,
          menu_selected_keys :['intro']
      }

  }
  public getLayoutConfig(){
    let enableDynamicLayout = true;
    let contentWidth:number = 1500;
    let contentHeight:number = 710;
    if(enableDynamicLayout && this.ContentRef){
      contentWidth = this.ContentRef.current.offsetWidth;
      contentHeight = this.ContentRef.current.offsetHeight;
    }
    return {
      contentWidth:contentWidth, 
      contentHeight:contentHeight
    }
  }
  public onResize(){
    this.updateLayoutState();
 }  
 public updateLayoutState(){
    let contentLayout = this.getLayoutConfig();
    let contentWidth = contentLayout.contentWidth;
    let contentHeight = contentLayout.contentHeight;
    //console.log("contentWidth, height", contentWidth, contentHeight)
   this.setState({
      contentWidth:contentWidth,
      contentHeight:contentHeight,
       screenHeight: window.innerHeight,
       screenWidth: window.innerWidth,
       
   })
 }
 componentDidMount(){
    window.addEventListener('resize', this.onResize)
    this.updateLayoutState();
 }
 componentDidUpdate(prevProps:IProps, prevState:IState) {
  // if(prevState.contentWidth!==this.state.contentWidth || )
  //this.updateLayoutState();
 }
  public onMenuSelect(event:any){
    console.log("Menu change", event.selectedKeys);
    let selectedKeys = event.selectedKeys;
    if(selectedKeys.length>=1){
      let selectedKey = selectedKeys[0];
      let blocked_keys = ["docs", "contact"];
      if(selectedKey == "download"){
        //window.location.href = "http://github.com"
        download("hapi.tar.gz", "https://storage.googleapis.com/hapi-data/hapi.tar.gz")
        return ;
      }
      if(blocked_keys.indexOf(selectedKey) >= 0){
        return ;
      }
    }
    this.setState({
      menu_selected_keys: event.selectedKeys
    })
    

    if(selectedKeys.length>=1){
      let selectedKey = selectedKeys[0];
      if(selectedKey === "intro"){
        this.props.changeViewMode(1);
      }else if(selectedKey === "metrics"){
        this.props.changeViewMode(2);
        this.props.changeMode(1);
      }else if(selectedKey === "explore"){
        this.props.changeViewMode(3);
        this.props.changeMode(2);
      }
    }
  }
  public render() {
    let {screenWidth, screenHeight, contentWidth, contentHeight} = this.state;
    console.log("contentWidth, height", contentWidth, contentHeight)
    
      let view_generator = (view_mode:any, viewWidth:any) => {
          if(view_mode === 1){
              return <IntroView contentWidth={viewWidth} contentHeight={contentHeight}/>;
          }else{
              return <DataRunsContainer contentWidth={viewWidth} contentHeight={contentHeight}/>;
          }

      }
      let generate_menu_items = () => {
        {/*<Menu.Item key="docs" icon={<FileOutlined />}>
              Docs
        </Menu.Item>,
      <Menu.Item key="contact" icon={<CommentOutlined />}>
            Contact
        </Menu.Item>*/}

        let menu_items:any = [
          <Menu.Item key="intro" icon={<ProfileOutlined />}>
            About
          </Menu.Item>,
          <Menu.Item key="metrics" icon={<LineChartOutlined />}>
            Examples Analysis
          </Menu.Item>,
          <Menu.Item key="explore" icon={<SearchOutlined />}>
            Explore
          </Menu.Item>,
           <Menu.Item key="download" icon={<DownloadOutlined />}>
            Download
         </Menu.Item>
        ];
        return menu_items;
      }
      let generate_menu = (mode:any, className:any) => {
        return <Menu key={"menu_1"} mode={mode} className={className} selectedKeys={this.state.menu_selected_keys} theme={"dark"} onSelect={this.onMenuSelect}>
                  {generate_menu_items()}
          </Menu> 
      }
      let generate_menu_2 = (mode:any, className:any) => {
        return <Menu key={"menu_2"} mode={mode} className={className} selectedKeys={this.state.menu_selected_keys} theme={"dark"} onSelect={this.onMenuSelect}>
                  <Menu.SubMenu key="SubMenu" title="" icon={<MenuFoldOutlined />}>
                  {generate_menu_items()}
                  </Menu.SubMenu>
                  
          </Menu> 
      }
      let generate_horizontal_menu = (enable:boolean, enableExpand:boolean=false) => {
        if(enable){
          if(enableExpand){
            return generate_menu("horizontal", "");
          }else{
            return generate_menu_2("horizontal", "");
          }
           
        }else{
          return <div />
        }
      }
      let generate_vertical_menu = (enable:boolean) => {
        if(enable){
          return generate_menu("vertical", "verticalmenu");
        }else{
          return <div />
        }
      }
      let breakpoint = 1100;
      let enableVerticalMenu = false;
      let enableHorizontalMenu = false;
      let enableExpandHorizontalMenu = false;
      let col_size_menu = 4;
      let col_size_content = 20;
      let viewWidth = contentWidth;
      let menu_float: "left" | "right" = "left";
      let menu_width = screenWidth - 137 - 50 - 100;
      if(menu_width<50){
        menu_width = 50;
      }
      if(screenWidth >= breakpoint){
        enableVerticalMenu = false;
        enableHorizontalMenu = true;
        enableExpandHorizontalMenu = true;
        col_size_menu = 0;
        col_size_content = 24;
        viewWidth = contentWidth;
        menu_float = "left";
      }else{
        enableVerticalMenu = false;
        enableHorizontalMenu = true;
        enableExpandHorizontalMenu = false;
        col_size_menu = 0;
        col_size_content = 24;
        viewWidth = contentWidth;
        menu_float = "right";
        menu_width = 100;
      }

    /*if(viewWidth < 700){
      viewWidth = 700;
    }*/

    return (
      <Layout className="app" >
         
          <Header className='appHeader'>
          {/*<div  style={{float:'left'}} className="appTitle">HAPI </div>*/}
          <div style={{float:'left'}} className="appTitle">
          <img src={Banner} style={{"height":"25px"}} alt="banner"/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          
          </div>
          <div style={{"float":menu_float, "width":""+menu_width+"px"}}>
            {generate_horizontal_menu(enableHorizontalMenu, enableExpandHorizontalMenu)}
          </div>
          </Header>
            <Content className='appContent' >
              <div style={{ "height": "100%", "width":"100%"}} ref={this.ContentRef}>
          
              <Row style={{ "height": "100%", "width":"100%"}} >
                <Col span={col_size_menu}>
                  {generate_vertical_menu(enableVerticalMenu)}
    </Col>
                <Col span={col_size_content} style={{ "height": "100%", "width":"100%", "overflow":"auto"}}>
                    {(contentWidth>0 && contentHeight >0)?view_generator(this.props.view_mode, viewWidth):<div />}
                </Col>
    </Row>
                </div>
                <div id="tooltip_proj" />
                <div id="tooltip_matrix" />
            </Content>
          
          
      </Layout>
    );
  }
}

export default App;
